export class UsernameTakenError extends Error {
  error: Error | unknown;

    constructor(message: string, error?: Error | unknown) {
        super(message);
        this.name = "UsernameTakenError";
        this.error = error;
    }
}
